<template>
  <div>
    <el-card
      class="card-container"
      shadow="never"
    >
      <CardHeader
        slot="header"
        title="Danh sách quy trình"
        :total="total"
        :size="'small'"
        :disabled="loading"
        @refresh="handleRefresh"
      />
      <div>
        <CardFilter />
        <CardList
          :data="data"
          :loading="loading"
        />
        <el-row
          type="flex"
          align="middle"
          justify="end"
          class="mt-l"
        >
          <el-pagination
            background
            :current-page="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="handleChangePageSize"
            @current-change="handleChangePage"
          />
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CardFilter from "./components/CardFilter.vue";
import CardHeader from "./components/CardHeader.vue";
import CardList from "./components/CardList.vue";

import contractServices from "@/services/contract";

export default {
  name: "Contracts",
  components: {
    CardHeader,
    CardFilter,
    CardList,
  },
  data() {
    return {
      loading: false,
      searchText: "",
      page: 1,
      pageSize: 10,
      total: 0,
      data: [],
      selectedItem: null,
      formVisible: false,
      organizationId: ''
    };
  },
  computed: {
    ...mapGetters("organization", ["selectedOrg"]),
    params() {
      const _params = {
        q: this.searchText,
        offset: (this.page - 1) * this.pageSize,
        limit: this.page * this.pageSize,
        locale: "vi",
        sort: "-created",
        filters: {
        }
      };
      if (this.selectedOrg) {
        _params.filters['organization_id'] = this.selectedOrg.id
      }
      return _params;
    },
  },
  watch: {
    selectedOrg: {
      handler() {
        this.fetchData()
      },
      deep: true,
      immediate: true,
    },
  },
  beforeMount() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      if (!this.selectedOrg) {
        return
      }
      this.loading = true;
      contractServices
        .list(this.params)
        .then((response) => {
          this.data = response.items.map((item, index) => ({
            ...item,
            stt: index + 1 + this.pageSize * (this.page - 1),
          }));
          this.total = response.meta.total;
          this.loading = false;
        })
        .catch(() => {
          this.data = [];
          this.loading = false;
        });
    },
    handleSearch() {
      this.page = 1;
      this.fetchData();
    },
    handleRefresh() {
      this.selectedItem = null;
      this.page = 1;
      this.searchText = "";
      this.fetchData();
    },
    handleChangePage(page) {
      this.page = page;
      this.fetchData();
    },
    handleChangePageSize(size) {
      this.page = 1;
      this.pageSize = size;
      this.fetchData();
    },
  },
};
</script>

<style lang="scss"></style>
